import newPlatenum from '../components/newPlatenum.vue'
// type=type=2显示字母键盘,returnHandler返回键盘值的回调方法,showmask控制是否要黑色遮罩背景
// <div class="cityP" v-platenum="{type: 1, returnHandler: returnHandler,showmask: false}" v-text='cityp'></div>
// <div class="engP" v-platenum="{type: 2, returnHandler: returnHandler,showmask: false}"  v-text='carNo'></div>
Vue.directive('newPlatenum', {
  inserted: (el, binding) => {
    let instance = null
    $(el).on('click', (e) => {
      e.preventDefault()
      let $content = $('.page-current').eq(tuhu.getParam('_tab') || 0).children('._content')
      let replaceEl = $('<div></div>')
      $content.append(replaceEl)
      if (instance) {
        instance.$children[0].showPlate = binding.value.type
        instance.$children[0].myShowmask = binding.value.showmask
        if (binding.value.type === 1) {
          instance.$children[0].cityVal = $(e.target).text()
          instance.$children[0].carVal = $(e.target).siblings().text()
        } else if (binding.value.type === 2) {
          instance.$children[0].cityVal = $(e.target).siblings().text()
          instance.$children[0].carVal = $(e.target).text()
        }
      } else {
        let cityV = ''
        let carV = ''
        if (binding.value.type === 1) {
          cityV = $(e.target).text()
          carV = $(e.target).siblings().text()
        } else if (binding.value.type === 2) {
          cityV = $(e.target).siblings().text()
          carV = $(e.target).text()
        }
        instance = new Vue({
          el: replaceEl[0],
          render: createElement => {
            return createElement(newPlatenum, {
              props: {
                showmask: binding.value.showmask,
                showP: binding.value.type,
                returnHandler: binding.value.returnHandler,
                cityV: cityV,
                carV: carV
              }
            })
          }
        })
      }
    })
  }
})



// WEBPACK FOOTER //
// ./lib/directives/newPlatenum.js